import register from 'preact-custom-element'
import { getProductTitle } from 'libs/shopify'
import CarouselSwiper from 'modules/carousel-swiper/carousel-swiper'
import PlpCard from 'snippets/plp-card/plp-card'

function ProductItems({ products }) {
  return products.map(
    (product) =>
      product && (
        <swiper-slide className="w-[234px] lg:w-[318px]">
          <PlpCard
            title={getProductTitle(product.title)}
            subtitle={product.metafields.sizes}
            handle={product.handle}
            imageUrl={[product.featuredImage]}
            price={product.price}
            originalPrice={product.compareAtPriceMin}
            tags={product.tags}
            linkedColors={product.metafields.linkedProducts.colors}
            currentSize={product.metafields.variantOptions.currentSize}
            sku={product.sku}
            className="plp-card-lookbook-carousel flex h-full flex-shrink-0 flex-col"
            showCallout={false}
            variants={product.variants}
          />
        </swiper-slide>
      )
  )
}

function LookbookProductCarousel() {
  const products = window.lookbookCarouselProducts

  const options = {
    slidesPerView: 'auto',
    spaceBetween: 16,
    freeMode: {
      enabled: true,
      sticky: true
    },
    grabCursor: true,
    speed: 500,
    breakpoints: {
      1024: {
        slidesPerView: 'auto',
        spaceBetween: 24
      }
    }
  }

  return (
    products.length > 0 && (
      <div className="overflow-hidden">
        <CarouselSwiper
          items={<ProductItems products={products} />}
          className="carousel-swiper-lookbook-products"
          options={options}
          navigation={true}
          scrollbar={true}
        />
      </div>
    )
  )
}

if (!customElements.get('lookbook-product-carousel')) {
  register(LookbookProductCarousel, 'lookbook-product-carousel')
}
